import { ApiService, IConfig, INameValue } from "./apiService";
import { IChangePasswordCommand, IResetPasswordCommand, IConfirmEmailCommand } from "../models";
import { QCCATSessionStorage } from "./qccatStorage";

export class AuthApi {
	private _apiService: ApiService;

	constructor(apiService: ApiService) {
		this._apiService = apiService;
	}

	public login = (user) => {
		return this._apiService.post("api/Auth/Login", { userName: user.username, Password: user.password});
	}

	public logout = () => {
		return this._apiService.post("api/AppAuth/Logout");
	}

	public createUser = (user) => {
		return this._apiService.post("api/Auth/CreateUser", user);
	}

	/**
	 * Promise to get users account details
	 */
	public getUsersAccountDetails = () => {
		return this._apiService.get(`api/Auth/GetUsersAccountDetails`);
	}

	/**
	 * Promise to change the password for the current user.
	 */
	public changePassword = (command: IChangePasswordCommand) => this._apiService.post("api/Auth/ChangePassword", command);

	/**
	 * Promise to reset the user's password.
	 */
	public resetPassword = (command: IResetPasswordCommand) => this._apiService.post("api/Auth/ResetPassword", command);

	/**
	 * Promise to confirm email.
	 */
	public confirmEmail = (command: IConfirmEmailCommand) => this._apiService.post("api/Auth/ConfirmEmail", command);
	
	/**
	 * Promise to request a user's password is reset
	 */
	public resetPasswordRequest = (email: string) => this._apiService.get("api/Auth/ResetPassword?email=" + email);

	/**
	 * Redirect the application to the next application url on success.
	 */
	public redirectToApplication(nextAppWebServiceUrl, nextAppApplicationUrl, loginUrl) {
		let redirectApiService = new ApiService( { apiUrl: nextAppWebServiceUrl, loginUrl: loginUrl });
		return redirectApiService.get("api/AppAuth/GetAccessToken", [])
						.then(response => {
							window.location.href = nextAppApplicationUrl + "Auth/" + (<any>response).oneTimeToken;
						})
						.catch(error => {
							throw(error);
						});
	}

	public authenticate = (oneTimeToken) => {
		let params = [ { name: "k", value: encodeURIComponent(oneTimeToken) }];
		return this._apiService.get("api/AppAuth/A", params);
	}

	public resyncAntiforgeryToken = () => {
		return this._apiService.get("api/AppAuth/R", []);
	}
}